import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 44 43"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F8BF08",
      "fill-rule": "evenodd",
      d: "M37.103 24.186c.166 3.824-1.092 8.233-4.773 12.81-1.193 1.484-1.214 3.654.13 5.002s3.539 1.358 4.76-.101c4.912-5.866 7.017-12.071 6.759-18.01-.293-6.747-3.615-12.67-8.382-16.887C26.813-.77 12.42-3.257 1.13 5.712-.36 6.895-.35 9.102.995 10.45s3.508 1.317 5.045.195c8.23-6.01 18.466-4.254 25.003 1.53 3.59 3.177 5.86 7.421 6.06 12.011",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }